import { useNavigate } from 'react-router-dom';
import { CloudUpload, UserRound } from 'lucide-react';
import { useAccount } from '@/lib/account';

export const AccountHint = ({ onSave }) => {
  const account = useAccount(), navigate = useNavigate();
  if (account === undefined) return null;
  if (account) return <span className="finish-account-hint is-in" data-testid="finish-account-saved"><UserRound size={14} />Gespeicherte Entwürfe findest du in deinem Konto, {account.name.split(' ')[0]}.</span>;
  return <button type="button" className="finish-account-hint" onClick={async () => { await onSave(); navigate('/konto?neu=1'); }} data-testid="finish-account-hint"><CloudUpload size={14} />Im Konto sichern – auf jedem Gerät weiterbearbeiten</button>;
};
